import { useEffect, useContext } from "react";
import { alertContext } from "./contexts/AlertProvider";

const Alert = () => {
  const [alertConfig, setAlertConfig] = useContext(alertContext);

  useEffect(() => {
    if (alertConfig.show) {
      setTimeout(() => {
        setAlertConfig({
          show: false,
          message: "",
          type: "",
        });
      }, 4000);
    }
  }, [alertConfig.show]);

  return (
    <div className="position-fixed top-0 end-0 p-3" style={{ zIndex: 99999 }}>
      <div
        className={
          alertConfig.show ? "toast show bg-" + alertConfig.type : "toast"
        }
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
      >
        <div className={"toast-header bg-" + alertConfig.type}>
          <i className="ki-duotone ki-abstract-39 fs-2 link-light me-3">
            <span className="path1"></span>
            <span className="path2"></span>
          </i>
          <strong className="me-auto link-light">
            {process.env.REACT_APP_BRAND_NAME || ""} Admin Panel
          </strong>
          <button
            onClick={() => {
              setAlertConfig({
                show: false,
                message: "",
                type: "",
              });
            }}
            type="button"
            className="btn-close"
            data-bs-dismiss="toast"
            aria-label="Close"
          ></button>
        </div>
        <div className="toast-body link-light">{alertConfig.message}</div>
      </div>
    </div>
  );
};

export default Alert;
